<template>
  <div class="section">
    <div class="swiper mySwiper">
    <div class="swiper-wrapper">
    <div class="swiper-slide">
      <div class="section contentItem1 yj_content">
        <div class="flexBg">

        </div>
        <div class="main_content middle">
          <div class="middle_left">
            <div
              v-for="it in modelType"
              class="top_cli"
              :key="it.id"
              @click="typeClick(it.id)"
              :class="middle == it.id ? 'hasback' : ''"
            >
              {{it.name}}
            </div>
          </div>

          <div class="middle_content">
            <div v-if="list.length">
              <div class="middle_content_title" v-for="it  in list" :key="it.aid" @click="godeatil(it)">
                <div class="needflex">
                  <img src="../../assets/phoneJoinUs/head.png" alt="">{{it.title}}
                </div>
                <div class="middle_p1">

                  <div>
                    {{it.deputyTitle}}
                  </div>
                  <div class="needwrap">
                    {{it.firstParagraph}}
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="middle_content_title">
              暂无
            </div>
          </div>

        </div>
      </div>
    </div>

    </div>
    <div class="swiper-scrollbar"></div>

  </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css"

export default {
  name: "product",

  watch: {
    screenWidth(newValue) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = newValue;
        this.timer = true;
        setTimeout(() => {
          //console.log(this.screenWidth);
          this.timer = false;
        }, 400);
      }
    }
  },
  data() {
    return {
      joblist: [],
      screenWidth: document.body.clientWidth,
      middle: 1,
      list: [],
      modelType:[
        {
          name: '市场类',
          id: 1
        },
        {
          name: '研发类',
          id: 2
        },
        {
          name: '产品类',
          id: 3
        },
        {
          name: '工程类',
          id: 4
        },
        {
          name: '职能/支持类',
          id: 5
        },
        {
          name: '采购类',
          id: 6
        },
        {
          name: '管理类',
          id: 7
        },
      ]
    };
  },
  mounted() {
    this.getLIst()
  },
  methods: {
    typeClick(index){
      this.middle = index
      this.list = this.joblist.filter(ele=>ele.recruitType == index)
    },

    getLIst(){
      this.$axios.post('/api/websiteRecruit/websiteList',{start: 1,limit: 500}).then(res=>{
        let list = res.data.data.records
        this.joblist = res.data.data.records
        this.list = list.filter(ele=>ele.recruitType == 1)
        console.log(this.list)
      })
    },
    godeatil(it){
      this.$router.push({
        path: '/jobDetail/' + it.aid + '.html'
      })
    }
  }
};
</script>

<style scoped lang="scss">
// @import "../../assets/style/product.scss";

.pro_wrap {
  text-align: left;
  width: 1200px;
  margin: auto;
  padding-top: 216px;
  display: flex;
  justify-content: space-between;
}
.title_1 {
  color: #ffffff;
  font-size: 60px;
  font-weight: initial;
  font-family: "PangMenZhengDao";
  letter-spacing: 6px;
}
.banner_btn {
  width: 120px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background: rgba(0, 0, 0, 0);
  border: 1px solid #ffffff;
  border-radius: 16px;
  font-size: 14px;
  font-family: "Regular";
  font-weight: 400;
  cursor: pointer;
  color: #ffffff;
}
.contentItem1 {
  background: url("../../assets/BG@2x.png");
  background-size: 100% 100%;
}


.weixin {
  display: flex;
  margin-left: 80px;
}

.weixin_it {
  display: flex;
  margin-left: 60px;
  flex-direction: column;
  text-align: center;
}

.item1_bottom {
  width: 1280px;
  margin: auto;
  padding-top: 20px;
  display: flex;
  justify-content: space-around;
}

.bto_left ul {
  list-style: none;
}

.bto_left ul > li {
  text-align: left;
  margin-bottom: 20px;
  color: #000;
}

.bottom_img {
  height: 400px;
  background: url("../../assets/pro/read.png");
  background-size: 100% 100%;
  margin-top: 60px;
  display: flex;
  justify-content: center;
  margin: auto;
}

.item {
  margin-top: 60px;
  width: 20%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
/* .img_item {
  height: 120px;
  width: 120px;
  background: rgb(49, 125, 247);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.img_item img {
  height: 60%;
  widows: 60%;
} */

.item ul {
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* .item ul > li:first-child {
  color: rgb(49, 125, 247);
  font-size: 16px;
} */

.item ul > li {
  margin-top: 10px;
  color: #625a5a;
}

.item ul > li span {
  padding: 0 5px;
}


/* .word {
  text-align: left;
  line-height: 30px;
  font-size: 20px;
  margin-top: 30px;
  margin-bottom: 30px;
  letter-spacing: 1px;
  color: rgb(74 64 64);
} */
.panelContent {
  padding-top: 30px;
  padding-bottom: 20px;
  width: 100%;
  margin: auto;
}

.contentItem {
  padding-top: 30px;
  padding-bottom: 20px;
  width: 1280px;
  margin: auto;
}

.middleImg {
  background: url("../../assets/pro/middle.png");
  background-size: 100% 100%;
  height: 400px;

  display: flex;
  align-items: center;
  justify-content: center;
}

.img_one {
  text-align: right;
  color: #fff;
  font-size: 30px;
}

.img_two {
  color: #fff;
  font-size: 24px;
  letter-spacing: 2px;
}

.flex_title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.title {
  margin-top: 30px;
  color: #484848;
  font-size: 24px;
}

.content {
  display: flex;
  text-align: center;
  padding-top: 25px;
  color: #999999;
  font-size: 14px;
}

.itemCard {
  width: 200px;
  height: 339px;
  padding: 20px;
}

.itemCard:hover {
  box-shadow: 0px 20px 29px 0px rgba(20, 50, 105, 0.23);
}

.typeTitle {
  color: #ffffff;
  font-size: 24px;
  padding-top: 30px;
  padding-bottom: 30px;
}

.dddssss {
  border-radius: 5px;
  border: 1px solid #f4f6fb;
  background-color: #ffffff;
  height: 80px;
  display: flex;
  text-align: center;
  box-shadow: 0px 0px 10px #dddddd;
  width: 1080px;
  justify-content: space-between;
}

.bbbbbbb {
  border-radius: 5px;
  border: 1px solid #f4f6fb;
  background-color: #ffffff;
  height: 80px;
  box-shadow: 0px 0px 10px #dddddd;
  width: 1080px;
  display: flex;
  justify-content: space-between;
}

.typeContent {
  color: #ffffff;
  font-size: 14px;
  text-align: center;
  padding: 10px 65px;
  line-height: 30px;
}

.feedbackCard {
  background-color: #ffffff;
  border: 1px solid #eeeeee;
  box-shadow: 2px 2px 5px #dddddd;
  height: 305px;
  margin-bottom: 60px;
  border-radius: 5px;
  display: flex;
}

.middle {
  height: 26vw;
  background: linear-gradient(90deg, #292E36, #292E36);
  box-shadow: 0px 18px 40px 0px rgba(122, 127, 139, 0.1);
  opacity: 0.8;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
}
.middle_left {
  text-align: left;
  margin-top: 40px;
  width: 220px;

}
 .hasback{
      border-left: #3170FF 4px solid;
      background: linear-gradient(90deg,rgba(49, 112, 255, 0.3),rgba(212, 225, 255, 0.1),rgba(212, 225, 255, 0.1),rgba(212, 225, 255, 0));
  }
.top_cli {
  width: 100%;
  color: #fff;
  height: 42px;
  line-height: 42px;
  padding-left: 40px;
  cursor: pointer;
}
.middle_content::-webkit-scrollbar {
  width: 10px;
  background: #3E4D6D;
}
.middle_content::-webkit-scrollbar {
  width: 10px;
  background: #3E4D6D;
}
/* 隐藏 IE 和 Edge 浏览器的滚动条 */
.middle_content::-ms-scrollbar {
  width: 10px;
  background: #3E4D6D;
}
@media screen and (min-width: 1024px) and (max-width: 1440px) {
  .middle_content{
    height: 32vh !important;
  }
  .flexBg{
    height: 210px !important;
  }
}
.middle_content {
  width: 300px;
  height: 40vh;
  margin-top: 40px;
  margin-left: 80px;
  flex: 1;
  color: #fff;
  text-align: left;
  overflow-y: scroll;
  .middle_p1{
    font-size: 14px;
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    color: #fff;
    line-height: 20px;
    div{
      padding:  15px 0 0 30px;
    }
    .needwrap{
      line-height: 20px;
      width: 600px;
    }
  }
  &_title{
    cursor: pointer;
    background: linear-gradient(90deg, rgba(92,118,169,0.1));
    margin-bottom: 20px;
    padding: 20px 10px;
  .needflex{
    display: flex;
    align-items: center;
    font-size: 18px;
  }
    img{
      height: 20px;
      margin-right: 10px;
    }
  }
}

.middle_right {
  margin-right: 40px;
  margin-top: 60px;

  img {
    width: 480px;
    height: 360px;
  }
}
.theSwiper {
  width: 1000px;
  /* height: 500px; */
  background: #292c30;
  margin: auto;
  margin-top: 82px;
}
.arrow_img {
  width: 41px;
  height: 41px;
  cursor: pointer;
}


.flexBg{
  height: 240px;
  background: url("../../assets/pic@2x.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.desc_ul {
  text-align: left;
  flex: 1;
  margin-top: 50px;
  width: 500px;
  box-sizing: border-box;
  padding-right: 60px;
  li {
    display: flex;
    align-items: flex-start;
    span {
      display: inline-block;
      font-size: 14px;
      font-family: "Regular";
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
      margin-bottom: 15px;
      margin-left: 10px;
    }
  }
}
.carousel_item {
  display: flex;
  align-items: center;
}
.carousel_imgWrap {
  display: flex;
  flex-wrap: wrap;
  margin-left: 60px;
  /* margin-top: 50px; */
  img {
    width: 180px;
    height: 180px;
  }
  img:nth-child(1) {
    margin-right: 40px;
  }
}
.jz_img {
  width: 320px;
  height: 320px;
  margin: 0px 100px 0 100px;
}
.subtitle {
  color: #ffffff;
  font-size: 24px;
  font-weight: initial;
  margin-top: 20px;
  font-family: "Regular";
}
>>> .el-carousel__container {
 height: 26vw
 /* height: 500px; */
}
</style>



// WEBPACK FOOTER //
// src/components/page/joinList.vue